import { useState, useEffect } from 'react';
import { useAdminAuth } from '../../context/AdminAuth';

const API_URL = 'https://nwt.am';const COMPONENTS = [
    { key: 'hero', label: 'Hero / Գլխավոր' },
    { key: 'about', label: 'About / Մեր մասին' },
    { key: 'contact', label: 'Contact / Կապ' },
    { key: 'blog', label: 'Blog / Նորություններ' },
    { key: 'general', label: 'General / Ընդհանուր' },
];

export default function AdminTranslations() {
    const { admin } = useAdminAuth();
    const [activeLang, setActiveLang] = useState('ARM');
    const [activeComponent, setActiveComponent] = useState('general');
    const [translations, setTranslations] = useState({});
    const [editingKey, setEditingKey] = useState(null);
    const [editValue, setEditValue] = useState('');

    useEffect(() => {
        loadTranslations();
    }, [activeComponent]);

    const loadTranslations = async () => {
    if (!admin?.token) return;
    try {
        const res = await fetch(`${API_URL}/translations/component/${activeComponent}`, {
            headers: { 'Authorization': `Bearer ${admin.token}` }
        });
        const text = await res.text();
        if (text) {
            const data = JSON.parse(text);
            setTranslations(data);
        } else {
            setTranslations({});
        }
    } catch (err) {
        console.error('Translations error:', err);
        setTranslations({});
    }
};

    const saveTranslation = async (textKey) => {
        await fetch(`${API_URL}/translations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${admin.token}`
            },
            body: JSON.stringify({
                component_key: activeComponent,
                text_key: textKey,
                lang: activeLang,
                text_value: editValue
            })
        });
        setEditingKey(null);
        loadTranslations();
    };

    return (
        <div>
            <h1 className="text-3xl font-black text-[#0B3B6F] uppercase mb-8">Թարգմանություններ</h1>
            
            {/* Выбор языка */}
            <div className="flex gap-2 mb-6">
                {['ARM', 'ENG', 'RU'].map((lang) => (
                    <button
                        key={lang}
                        onClick={() => setActiveLang(lang)}
                        className={`px-6 py-2 text-sm font-bold uppercase ${
                            activeLang === lang
                                ? 'bg-[#0FA4E8] text-white'
                                : 'bg-gray-100 text-[#0B3B6F] hover:bg-gray-200'
                        }`}
                    >
                        {lang === 'ARM' ? 'Հայ' : lang === 'ENG' ? 'Eng' : 'Рус'}
                    </button>
                ))}
            </div>

            {/* Выбор компонента */}
            <div className="flex gap-2 mb-6 flex-wrap">
                {COMPONENTS.map((comp) => (
                    <button
                        key={comp.key}
                        onClick={() => setActiveComponent(comp.key)}
                        className={`px-4 py-2 text-xs font-bold uppercase ${
                            activeComponent === comp.key
                                ? 'bg-[#0B3B6F] text-white'
                                : 'bg-gray-100 text-[#0B3B6F] hover:bg-gray-200'
                        }`}
                    >
                        {comp.label}
                    </button>
                ))}
            </div>

            {/* Список переводов */}
            <div className="space-y-2">
                {Object.entries(translations).map(([key, values]) => (
                    <div key={key} className="bg-white p-4 shadow-sm">
                        <p className="text-xs text-slate-400 mb-1">{key}</p>
                        {editingKey === key ? (
                            <div className="flex gap-2">
                                <input
                                    type="text"
                                    value={editValue}
                                    onChange={(e) => setEditValue(e.target.value)}
                                    className="flex-1 border border-gray-200 px-3 py-2 text-sm focus:border-[#0FA4E8]"
                                    autoFocus
                                />
                                <button onClick={() => saveTranslation(key)} className="px-4 py-2 bg-[#0FA4E8] text-white text-xs font-bold uppercase">Պահպանել</button>
                                <button onClick={() => setEditingKey(null)} className="px-4 py-2 bg-gray-200 text-xs font-bold uppercase">Չեղարկել</button>
                            </div>
                        ) : (
                            <p
                                className="text-sm text-[#0B3B6F] cursor-pointer hover:text-[#0FA4E8]"
                                onClick={() => { setEditingKey(key); setEditValue(values[activeLang] || ''); }}
                            >
                                {values[activeLang] || '(թարգմանված չէ)'}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}